import { BrowserRouter, Routes, Route } from "react-router-dom"
import Iniciar from "./Iniciar";
import Registro from "./Registro";
export default function Inicio({iniciar}) {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Iniciar iniciar={iniciar} />}/>
                <Route path="/Registrar" element={<Registro iniciar={iniciar} />} />               
                <Route path="*" element={<Iniciar iniciar={iniciar} />} />
            </Routes>
        </BrowserRouter>
    )
};
